import { makeStyles } from '@material-ui/core/styles';
import sheetFormStyles
  from 'pages/Worklogs/components/SheetForm/styles';

export default makeStyles(sheetFormStyles);
